import { formatPhone } from '@seccon/shared/utils/format';

/**
 * Formats US phone numbers returned from form fields into a normalized format, XXX-XXX-XXXX
 * @param {string} fieldName - name of the field whose value will be normalized
 * @param {Function} setValue - callback function to set the form field
 * @param {string} value - value to be normalized
 */
function formatPhoneField (fieldName, setValue, value) {
  const newValue = formatPhone(value);

  // If the old and new value change, then set the new value
  if (value !== newValue) {
    setValue(fieldName, newValue);
  }
}

export default formatPhoneField;
